﻿function setSearchListeners() {
    const searchTab = document.querySelector("[data-search=tab]");
    const searchTabInput = document.querySelector("[data-search=input]");
    const searchTabClose = document.querySelector("[data-search=close]");
    const MOBILE_VIEW_CLASS = "mobile-view";

    if (searchTabInput && searchTab) {

        searchTabInput.addEventListener("click", () => {
            const isMobileViewActive = searchTab.classList.contains(MOBILE_VIEW_CLASS);

            if (!isMobileViewActive) {
                searchTab.classList.add(MOBILE_VIEW_CLASS);
            }
        });
    }

    if (searchTabClose && searchTab && searchTabInput) {
        searchTabClose.addEventListener("click", () => {
            searchTab.classList.remove(MOBILE_VIEW_CLASS);
            searchTabInput.value = "";
        });
    }

}

setSearchListeners();
